import sanitize from '../../../utilities/parseHTML/purify';
import parseHTML from '../../../utilities/parseHTML';
import { sanitizeBreadcrumbs } from '../../../utilities/breadcrumbs';

export const genSocialLinks = (socialLinks) => socialLinks.map(
    ({channel, url}) => ({ channel, url: sanitize( url )})
)

const authorBioPropsTransformer = (queried) => 
{
    const {
        displayName,
        education,
        expertise,
        socialLinks = [],
    } = queried?.author?.cdmfields?.author;

    const authorSocial = genSocialLinks(socialLinks);

    const authorBioProps = { 
        authorImage: queried?.author?.localAvatar?.childImageSharp?.gatsbyImageData || false,
        socialLinks: authorSocial,
        displayName: displayName ? parseHTML(displayName, ['learningCenter']).parsed : false,
        uri: queried?.author?.uri || false,
    };

    const breadcrumbs = sanitizeBreadcrumbs(queried?.author?.cdmfields?.breadcrumb);
    
    return {
        editorialMarkup: queried?.editorialStandards?.content ? parseHTML(queried.editorialStandards.content, ['learningCenter']).parsed : false,
        authorBioProps,
        xpInfoMarkup: {
            expertise: expertise ? parseHTML(expertise, ['learningCenter']).parsed : false,
            education: education ? parseHTML(education, ['learningCenter']).parsed : false,
        },
        biographyProps: queried?.author?.description ? parseHTML(queried?.author?.description).parsed : false,
        breadcrumbs
    } 
}

export default authorBioPropsTransformer;